import { ISODateType } from '@principle-theorem/shared';
import { Gender } from '../../patient/patient';
import { IMohPdfTreatment } from './moh';

export interface IMohOhsaIndividualTreatmentData {
  patientNhiNumber: string;
  patientFirstName: string;
  patientLastName: string;
  patientDateOfBirth: ISODateType;
  patientGender: Gender;
  schoolAttended: string;
  schoolNumber: string;
  schoolEqiCode: string;
  annualConsultDate: ISODateType;
  annualConsultDone: boolean;
  annualCapitatedFee: number;
  standardCodes: string[];
  additionalTreatments: IMohPdfTreatment[];
  preApprovalTreatments: IMohPdfTreatment[];
  approvalNumber?: string;
}

export interface IMohOhsaClaimSummaryData {
  claimUid: string;
  payeeNumber: string;
  agreementNumber: string;
  agreementHolderName: string;
  practitionerName: string;
  dcnzNumber: string;
  numberOfPatients: number;
  totalExGst: number;
  gstAmount: number;
  totalIncGst: number;
  signatureDate: ISODateType;
}
